<template>
  <ATooltip placement="bottom-end" class="popover--author-info">
    <div class="author-info-popover__icon-container" data-test-id="author-info-button">
      <ClockIcon16 />
    </div>

    <template #popper>
      <AuthorInfo :entity="entity" :entity-type="entityType" line-break />
    </template>
  </ATooltip>
</template>

<script>
import AuthorInfo from '@components/common/AuthorInfo.vue';
import ClockIcon16 from '@components/Icons/ClockIcon16.vue';

export default {
  name: 'AuthorInfoPopover',

  components: {
    AuthorInfo,
    ClockIcon16,
  },

  props: {
    entity: {
      type: Object,
      required: true,
    },
    entityType: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
.popover--author-info {
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: settings.$border-radius;
  transition: all 0.1s ease-in-out;
  height: 28px;
  width: 28px;

  cursor: pointer;
  background: transparent;
  color: colors.$color-grey-700;
  box-shadow: none;

  &:focus-within,
  &:hover {
    color: colors.$color-blue;
    background: colors.$color-blue-100;
  }
}

.author-info-popover__icon-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
